import React from "react";
import Counter from "./components/Counter";
import { ElementViewProps, CounterSettings } from "@/shared/types";

export interface CounterViewProps extends ElementViewProps {}

const CounterView: React.FC<CounterViewProps> = ({ element }) => {
  const counterSettings = element?.settings as CounterSettings;

  return <Counter counterSettings={counterSettings} />;
};

export { CounterView };
